import { useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useCustomer } from "@/context/CustomerContext";
import { errMsg } from "@/lib/api";
import { inputCls, btnPrimary } from "@/lib/labels";
import { AuthShell, FormError } from "@/components/account/AuthShell";
import { PasswordInput, Field } from "@/components/account/PasswordInput";
import { LogoDrop } from "@/components/site/LogoDrop";

export default function Register() {
  const { customer, register } = useCustomer();
  const [params] = useSearchParams();
  const next = params.get("next") || "/account";
  const nav = useNavigate();
  const [f, setF] = useState({ brand_name: "", phone: "", email: "", password: "" });
  const [logo, setLogo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  if (customer) return <Navigate to={next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.password.length < 8) return setError("كلمة السر لازم تكون 8 حروف على الأقل");
    if (!logo) return setError("ارفع لوجو البراند");
    const fd = new FormData();
    Object.entries(f).forEach(([k, v]) => fd.append(k, k === "password" ? v : v.trim()));
    fd.append("logo", logo);
    setBusy(true);
    try {
      await register(fd);
      nav(next);
    } catch (err) {
      setError(errMsg(err, "مش قادرين نعمل الحساب"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="اعمل حسابك" subtitle="حساب واحد تطلب منه كل إعلاناتك، وبياناتك بتتملى لوحدها كل مرة." testId="customer-register-page">
      <form onSubmit={submit} className="space-y-4" data-testid="customer-register-form">
        <Field label="اسم البراند">
          <input className={inputCls} value={f.brand_name} onChange={set("brand_name")} maxLength={120} required data-testid="register-brand-input" />
        </Field>
        <Field label="رقم الموبايل / واتساب">
          <input type="tel" dir="ltr" className={`${inputCls} text-right`} value={f.phone} onChange={set("phone")} placeholder="+20 10 0000 0000" required data-testid="register-phone-input" />
        </Field>
        <Field label="الإيميل">
          <input type="email" dir="ltr" autoComplete="email" className={`${inputCls} text-right`} value={f.email} onChange={set("email")} required data-testid="register-email-input" />
        </Field>
        <Field label="كلمة السر" hint="8 حروف على الأقل">
          <PasswordInput value={f.password} onChange={set("password")} autoComplete="new-password" testId="register-password-input" />
        </Field>
        <div>
          <span className="font-head mb-1.5 block text-sm font-bold text-white">لوجو البراند</span>
          <LogoDrop file={logo} onChange={setLogo} />
        </div>
        <FormError msg={error} />
        <button type="submit" disabled={busy} className={`${btnPrimary} w-full`} data-testid="register-submit-btn">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} اعمل الحساب
        </button>
        <p className="text-center text-sm">
          <Link to={`/login?next=${encodeURIComponent(next)}`} className="text-[var(--km-lilac)] underline" data-testid="go-login-link">عندك حساب؟ سجل دخول</Link>
        </p>
      </form>
    </AuthShell>
  );
}
